// @flow
import {LoadingButton} from "@mui/lab";
import React, {useMemo} from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField, Tooltip,
    Typography
} from "@mui/material";
import {useTranslation} from "react-i18next";
import {CalculateOutlined, Cancel, Check} from "@mui/icons-material";
import { Permissions } from "../../../../helpers/constants";
import {CONFIRMATION, PRODUCT_DETAIL} from "../../../../locales/components/namespaces";
import Box from "@mui/material/Box";
import {NumericFormat} from "react-number-format";
import useUserData from "../../../../hooks/user/useUserData";
import Button from "@mui/material/Button";
import { useHasPermission } from "../../../../modules/permission/hooks/useHasPermission";
import HalfCalculator from "../../dialogs/calculator/halfCalculator";
import {enqueueSnackbar} from "notistack";
import { applyPercentage, roundToDecimal } from "../../../../helpers/helpers";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import dayjs from "dayjs";

type Props = {
    open: boolean,
    handleDialog: Function,
    itemId: number | string,
    markDotDirty?: (itemId: number | string, warhId: number | string) => void,
};

const DotSelection = (props: Props) => {
    const {
        prices,
        halfCalculatorOpen,
        handleHalfCalculator,
        open,
        data,
        qtyLimits,
        dotsState,
        setDotsState,
        handleDialog,
        title,
        onYes = () => {
        },
        onNo = () => {
        },
        yesBtnText,
        noBtnText,
        hasBtnIcons = true,
        yesAction = true,
        noAction = true,
        maxWidth = 'md',
        loading = false,
        markDotDirty,
        itemId
    } = props
    console.log("data",data)
    const {t} = useTranslation(CONFIRMATION)
    const {thousandSeparator, decimalSeparator, dateFormat} = useUserData()
	const isAdmin = useHasPermission([Permissions.AccessAdmin], {shouldView: true})
    const handleClose = (evt, details) => {
        if (details === 'backdropClick') return
        handleDialog(false)
    }
    const finalCost = (extraPct) => {
        return roundToDecimal(applyPercentage(prices?.priceAfterDiscounts, extraPct, true), 2)
    };

    const finalCostWithVat = (extraPct) => {
        return roundToDecimal(
            Number(prices?.priceWithPaymentDiscountWithEnvTaxAndItemTax ?? 0) *
            (1 - extraPct / 100),
            2
        );
    };

    return (
        <Dialog open={open} onClose={handleClose}
                sx={{
                    maxWidth:'100%'
                }}>
            <DialogTitle>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}>
                    <Box sx={{mt:2}}>
                        <Tooltip title={'Υπολογισμοί'}>
                            <Button
                                variant={'text'}
                                sx={{minHeight: 0, minWidth: 0, padding: 0}}
                                onClick={() => handleHalfCalculator({
                                    open: true
                                })}
                            >
                                <CalculateOutlined fontSize={'large'} p={0}/>
                            </Button>
                        </Tooltip>
                    </Box>
                    <Box
                    sx={{mt:2}}>
                        <Button
                            color="error"
                            size={"small"}
                            variant={"outlined"}
                            onClick={handleClose}
                            //startIcon={<Cancel/>}
                            sx={{
                                marginRight: 'auto'
                            }}
                        >
                            {t('Close')}
                        </Button>
                    </Box>
                </Box>
            </DialogTitle>
            <DialogContent sx={{mt: 3}}>
                <DialogContentText component={'div'}>
                    {Array.isArray(data) && data.length > 0 ? (
                        data.map((w) => {
                            const rows = Array.isArray(w.dots) ? w.dots : [];
                            if (rows.length === 0) return null;

                            const limit = qtyLimits[w.id] || 0;
                            const currentMap = dotsState?.[w.id] || {};
                            const sumSelected = Object.values(currentMap).reduce((acc, v) => acc + (Number(v) || 0), 0);
                            const remaining = Math.max(0, limit - sumSelected);

                            return (
                                <Box key={w.id} sx={{
                                    mb: 2,
                                    p: 1,
                                    border: '1px solid rgba(0,0,0,0.12)',
                                    borderRadius: 1,
                                    backgroundColor: '#fff'
                                }}>
                                    <Typography variant="subtitle2" sx={{mb: 0.5}}>
                                        Αποθήκη #{w.address} — Ζητούμενα: {limit} | Επιλεγμένα: {sumSelected} |
                                        Υπόλοιπο: {remaining}
                                    </Typography>

                                    {/* Header */}
                                    <Box sx={{
                                        display: 'grid',
                                        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
                                        fontSize: 13,
                                        fontWeight: 600,
                                        borderBottom: '1px solid rgba(0,0,0,0.12)',
                                        pb: 0.5
                                    }}>
                                        <Box>{t('Year')}</Box>
                                        <Box>{t('Quantity')}</Box>
                                        <Box>{t('Discount')}</Box>
                                        <Box>{t('Quantity you want')}</Box>
                                        <Box sx={{textAlign: 'right', fontWeight: 'bold'}}>{t('Item without Tax')} (€)</Box>
                                        {/*<Box sx={{textAlign: 'right', fontWeight: 'bold'}}>{t('Item with Tax')} (€)</Box>*/}
                                    </Box>

                                    {/* Rows */}
                                    {rows.map((d, i) => {
                                        const year = String(d?.DotYear ?? '');
                                        const curVal = currentMap[year] ?? '';
                                        //const yearMaxQty = Number(d?.Qty) || 0;
                                        const yearMaxQty = Number(limit) || 0;

                                        const qty = yearMaxQty;
                                        const showQty = Number(d.Qty) > 0 ? (
												Number(d.Qty) > Number(d.displayStock) && !isAdmin ?
													`${Number(d.displayStock)}+`
													: `${Number(d.Qty)}`)
											: 0
                                            // d?.displayStock && d?.displayStock < d?.Qty
                                            //     ? `${d?.displayStock}+`
                                            //     : String(d?.Qty??'');

                                        return (
                                            <Box key={`${year}-${i}`} sx={{
                                                display: 'grid',
                                                gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
                                                alignItems: 'center', fontSize: 13, py: 0.5,
                                                borderBottom: i < rows.length - 1 ? '1px dashed rgba(0,0,0,0.08)' : 'none',
                                            }}>
                                                <Box>{year}</Box>
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    gap: 1,
                                                    minWidth: 0
                                                }}>
                                                    <Box sx={{flexShrink: 0}}>{showQty}</Box>
                                                    {d?.expectedDate && (
                                                        <Box sx={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            flexShrink: 0,
                                                            fontStyle: 'italic',
                                                            whiteSpace: 'nowrap'
                                                        }}>
                                                            <Box sx={{display: 'flex', alignItems: 'center'}}>
                                                                <Typography color="primary" variant="caption"
                                                                            component="span" sx={{fontSize: 11}}>
                                                                    <sup>*</sup>
                                                                    {dayjs(d.expectedDate).format(dateFormat)}
                                                                </Typography>
                                                                <LocalShippingIcon color="primary"
                                                                                   sx={{fontSize: 13, ml: 0.4, mt: 0.1}}/>
                                                            </Box>
                                                            <Typography color="primary" variant="caption"
                                                                        component="div"
                                                                        sx={{fontSize: 9, lineHeight: 1.2}}>
                                                                {Number(d?.expectedQty) > 20 ? '20+' : Number(d?.expectedQty)}{' '}
                                                                {t('expected pieces', {ns: PRODUCT_DETAIL})}
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                                <Box>{Number(d?.DiscountPCT) > 0 ? `${Number(d.DiscountPCT)}%` : ''}</Box>
                                                <Box>
                                                    <NumericFormat
                                                        thousandSeparator={thousandSeparator}
                                                        decimalSeparator={decimalSeparator}
                                                        value={curVal}
                                                        // onValueChange={(values) => {
                                                        //     const raw = values.value;
                                                        //     const next = raw === ''
                                                        //         ? ''
                                                        //         : Math.max(0, Math.floor(Number(values.floatValue ?? 0)));
                                                        //     const prevVal = Number(curVal) || 0;
                                                        //     const delta = (Number(next) || 0) - prevVal;
                                                        //     const newSum = sumSelected + delta;
                                                        //
                                                        //     let adjusted = next;
                                                        //     if (newSum > limit) {
                                                        //         const allowedExtra = Math.max(0, limit - (sumSelected - prevVal));
                                                        //         adjusted = String(allowedExtra);
                                                        //     }
                                                        //
                                                        //     setDotsState((prev) => ({
                                                        //         ...prev,
                                                        //         [w.id]: {
                                                        //             ...(prev?.[w.id] || {}),
                                                        //             [year]: adjusted === '' ? '' : Number(adjusted),
                                                        //         },
                                                        //     }));
                                                        //     markDotDirty?.(itemId, w.id);
                                                        // }}
                                                        onValueChange={(values) => {
                                                            const raw = values.value;

                                                            if (raw === '') {
                                                                setDotsState((prev) => ({
                                                                    ...prev,
                                                                    [w.id]: {
                                                                        ...(prev?.[w.id] || {}),
                                                                        [year]: '',
                                                                    },
                                                                }));
                                                                markDotDirty?.(itemId, w.id);
                                                                return;
                                                            }

                                                            let nextNum = Math.max(
                                                                0,
                                                                Math.floor(Number(values.floatValue ?? 0))
                                                            );

                                                            if (nextNum > yearMaxQty) {
                                                                enqueueSnackbar(
                                                                    t('DOT year max exceeded', { year, max: yearMaxQty }),
                                                                    { variant: "warning" }
                                                                );

                                                                nextNum = yearMaxQty;
                                                            }

                                                            const prevVal = Number(curVal) || 0;
                                                            const delta = nextNum - prevVal;
                                                            let newSum = sumSelected + delta;

                                                            if (newSum > limit) {
                                                                const allowedExtra = Math.max(
                                                                    0,
                                                                    limit - (sumSelected - prevVal)
                                                                );

                                                                enqueueSnackbar(
                                                                    t('DOT warehouse limit exceeded', { limit }),
                                                                    { variant: "warning" }
                                                                );


                                                                nextNum = prevVal + allowedExtra;
                                                                if (nextNum > yearMaxQty) {
                                                                    nextNum = yearMaxQty;
                                                                }
                                                                newSum = sumSelected - prevVal + nextNum;
                                                            }

                                                            setDotsState((prev) => ({
                                                                ...prev,
                                                                [w.id]: {
                                                                    ...(prev?.[w.id] || {}),
                                                                    [year]: nextNum,
                                                                },
                                                            }));
                                                            markDotDirty?.(itemId, w.id);
                                                        }}
                                                        decimalScale={0}
                                                        customInput={TextField}
                                                        size={'small'}
                                                        sx={{width: '60px'}}
                                                        type={'number'}
                                                        inputProps={{
                                                            min: 0,
                                                            style: {textAlign: 'center'},
                                                            max: yearMaxQty,
                                                            type: 'number'
                                                        }}
                                                    />
                                                </Box>
                                                <Box  sx={{textAlign: 'right', fontWeight: 'bold'}}>
                                                    {finalCost(Number(d?.DiscountPCT))}
                                                </Box>
                                                {/*<Box  sx={{textAlign: 'right', fontWeight: 'bold'}}>*/}
                                                {/*    {finalCostWithVat(Number(d?.DiscountPCT))}*/}
                                                {/*</Box>*/}
                                            </Box>
                                        );
                                    })}
                                </Box>
                            );
                        })
                    ) : (
                        <Typography variant="body2" sx={{opacity: 0.7}}>
                            {t('There are no selected warehouses dots')}
                        </Typography>
                    )}
                </DialogContentText>
                <HalfCalculator
                    open={halfCalculatorOpen}
                    handleDialog={handleHalfCalculator}/>
            </DialogContent>
            <DialogActions>
                {/*{noAction && (*/}
                {/*    <LoadingButton*/}
                {/*        color="error"*/}
                {/*        size={"small"}*/}
                {/*        variant={"contained"}*/}
                {/*        onClick={onNo}*/}
                {/*        startIcon={hasBtnIcons ? <Cancel/> : null}*/}
                {/*        sx={{*/}
                {/*            marginRight: 'auto'*/}
                {/*        }}*/}
                {/*        loading={loading}*/}
                {/*    >*/}
                {/*        {noBtnText ? noBtnText : t('NO')}*/}
                {/*    </LoadingButton>*/}
                {/*)}*/}
                {yesAction && (
                    <LoadingButton
                        size={"small"}
                        variant={"contained"}
                        color={'success'}
                        onClick={onYes}
                        startIcon={hasBtnIcons ? <Check/> : null}
                        loading={loading}
                    >
                        {yesBtnText ? yesBtnText : t('YES')}
                    </LoadingButton>
                )}
            </DialogActions>
        </Dialog>
    )
        ;
};

export default DotSelection